import { type LazyExoticComponent, type NamedExoticComponent, lazy } from "react"

import type { TParticipantHeaderJourneyAchievementsProps } from "./participant.header.journey-achievements.component"
import type { TParticipantHeaderModulesExcerptsProps } from "./participant.header.modules-excerpts.component"

const ParticipantHeaderJourneyAchievements: LazyExoticComponent<
        NamedExoticComponent<TParticipantHeaderJourneyAchievementsProps>
    > = lazy(
        (): Promise<{ default: NamedExoticComponent<TParticipantHeaderJourneyAchievementsProps> }> =>
            import("./participant.header.journey-achievements.component").then(
                ({
                    ParticipantHeaderJourneyAchievements: JourneyAchievements
                }): { default: NamedExoticComponent<TParticipantHeaderJourneyAchievementsProps> } => ({
                    default: JourneyAchievements
                })
            )
    ),
    ParticipantHeaderModulesExcerpts: LazyExoticComponent<
        NamedExoticComponent<TParticipantHeaderModulesExcerptsProps>
    > = lazy(
        (): Promise<{ default: NamedExoticComponent<TParticipantHeaderModulesExcerptsProps> }> =>
            import("./participant.header.modules-excerpts.component").then(
                ({
                    ParticipantHeaderModulesExcerpts: ModuleExcerpts
                }): { default: NamedExoticComponent<TParticipantHeaderModulesExcerptsProps> } => ({
                    default: ModuleExcerpts
                })
            )
    )

export { ParticipantHeaderModulesExcerpts, ParticipantHeaderJourneyAchievements }
export { participantHeaderHelperComponents } from "./participant.header.helpers-components"
